// The visitor's ad data consent (HubSpot contact property ttd_ad_data_consent),
// sent with the booking as ad_measurement_consent: true / false, or left out
// when unknown.
//
// - UK booking subdomain (.co.uk): the cookie banner's ttd_consent cookie
//   ("all" / "necessary", shared with the main UK site on
//   .tapestodigital.co.uk). Until it is set, a ttd_adc=1/0 added to the
//   booking link by the main site is used.
// - Anywhere else: only ttd_adc from the URL.
// - AU bookings get no value — the backend drops it for AU locations, since
//   the booked location (not the domain) decides the country.
//
// The URL value is kept in sessionStorage so it survives the multi-step flow.

const URL_KEY = "t2d_adc_url";
const CONSENT_COOKIE = "ttd_consent";
const CONSENT_MAX_AGE = 60 * 60 * 24 * 180;

// Fallback when storage is blocked (private mode): this page view only
const memory = {};

function readBool(key) {
  try {
    const value = sessionStorage.getItem(key);
    return value === "true" ? true : value === "false" ? false : null;
  } catch (e) {
    return memory[key] ?? null;
  }
}

function writeBool(key, value) {
  memory[key] = value;
  try {
    sessionStorage.setItem(key, String(value));
  } catch (e) {
    // memory copy above is enough for this page view
  }
}

export const isUkBookingDomain = (hostname = window.location.hostname) =>
  hostname.slice(-6) === ".co.uk";

// "all" | "necessary" | null when the visitor hasn't chosen yet
export function getConsentChoice() {
  const match = document.cookie.match(/(?:^|; )ttd_consent=([^;]+)/);
  const value = match ? match[1] : null;
  return value === "all" || value === "necessary" ? value : null;
}

// The cookie banner's buttons. choice: "all" or "necessary"
export function setConsent(choice) {
  const g = choice === "all" ? "granted" : "denied";
  document.cookie =
    `${CONSENT_COOKIE}=${choice}; domain=.tapestodigital.co.uk; path=/; ` +
    `max-age=${CONSENT_MAX_AGE}; SameSite=Lax; Secure`;
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: g,
      analytics_storage: g,
      ad_user_data: g,
      ad_personalization: g,
    });
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: "consent_update", consent_choice: choice });
}

// Call once on app start with the landing URL's query string.
export function initAdConsent({ search = "" } = {}) {
  // A newer booking link carrying ttd_adc replaces an older one's value
  const adc = new URLSearchParams(search).get("ttd_adc");
  if (adc === "1" || adc === "0") writeBool(URL_KEY, adc === "1");
}

// true / false, or null when unknown (never sent as empty)
export function getAdConsent() {
  const choice = isUkBookingDomain() ? getConsentChoice() : null;
  return choice !== null ? choice === "all" : readBool(URL_KEY);
}
